import type { SnackbarEntry } from './workspaceContextTypes';

export const MAX_VISIBLE_SNACKBARS = 3;

export const closeEntry = (
  entries: SnackbarEntry[],
  id: number
): SnackbarEntry[] => {
  const target = entries.find((entry) => entry.id === id);
  if (!target?.isOpen) {
    return entries;
  }
  if (!target.hasEntered) {
    return entries.filter((entry) => entry.id !== id);
  }
  return entries.map((entry) =>
    entry.id === id ? { ...entry, isOpen: false } : entry
  );
};

export const markEnteredEntry = (
  entries: SnackbarEntry[],
  id: number
): SnackbarEntry[] =>
  entries.some((entry) => entry.id === id && !entry.hasEntered)
    ? entries.map((entry) =>
        entry.id === id ? { ...entry, hasEntered: true } : entry
      )
    : entries;

export const addEntry = (
  entries: SnackbarEntry[],
  entry: SnackbarEntry
): SnackbarEntry[] => {
  const added = [...entries, entry];
  const openEntries = added.filter(({ isOpen }) => isOpen);
  if (openEntries.length <= MAX_VISIBLE_SNACKBARS) {
    return added;
  }
  return closeEntry(added, openEntries[0].id);
};

export const removeEntry = (
  entries: SnackbarEntry[],
  id: number
): SnackbarEntry[] => entries.filter((entry) => entry.id !== id);
